<template lang="pug">
  .clusterize
    #scrollArea.clusterize-scroll
      table.tablex.fixed-header-table#contentArea.clusterize-content(style="width: auto;").mb-5
        thead
          tr
            th(style="width: 80px;" rowspan="2")
              div {{ $t('ui.time') }}
            th(style="width: 450px;" rowspan="2")
              div {{ $t('ui.event') }}
            th(colspan="2")
              div.text-center {{ $t('ui.full_time') }}
            th(colspan="2")
              div.text-center {{ $t('ui.half_time') }}
            th(colspan="5")
              div.text-center {{ $t('ui.total_goal') }}
          tr
            th(style="width: 100px;")
              div {{ $tc('ui.odds', 1) }}
            th(style="width: 100px;")
              div {{ $t('ui.even') }}
            th(style="width: 100px;")
              div {{ $tc('ui.odds', 1) }}
            th(style="width: 100px;")
              div {{ $t('ui.even') }}
            th(style="width: 100px;")
              div 0-1
            th(style="width: 100px;")
              div 2-3
            th(style="width: 100px;")
              div 4-6
            th(style="width: 100px;")
              div 7+
        tbody(v-for="(item, index) in cacheList")
          tr
            td(style="width: 80px;")
              div {{ item.mt == 'live'? item.rs : item.ed }}
              div {{ item.mt == 'live'? item.rt : item.et }}
            td(style="width: 450px;")
              div.text-info {{ item.th }}
              div.text-warning {{ item.ta }}
              div.text-danger {{ item.ln }}
            td(style="width: 100px;")
              div(:class="{'up': item.fodd_blink }") {{ item.fodd }}
            td(style="width: 100px;")
              div(:class="{'up': item.feven_blink }") {{ item.feven }}
            td(style="width: 100px;")
              div(:class="{'up': item.hodd_blink }") {{ item.hodd }}
            td(style="width: 100px;")
              div(:class="{'up': item.heven_blink }") {{ item.heven }}
            td(style="width: 100px;")
              div(:class="{'up': item['ftg0-1_blink'] }") {{ item['ftg0-1'] }}
            td(style="width: 100px;")
              div(:class="{'up': item['ftg2-3_blink'] }") {{ item['ftg2-3'] }}
            td(style="width: 100px;")
              div(:class="{'up': item['ftg4-6_blink'] }") {{ item['ftg4-6'] }}
            td(style="width: 100px;")
              div(:class="{'up': item['ftg7-o_blink'] }") {{ item['ftg7-o'] }}
</template>
<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: ""
    },
    cacheList: {
      type: Array,
      default: ""
    },
    betType: {
      type: String,
      default: ""
    },
    sportType: {
      type: String,
      default: ""
    },
    marketType: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    cleanup() {
      this.$forceUpdate();
    }
  }
};
</script>